<!-- <mat-radio-group (change)="onChangeAnnuncementTypeFilter($event)" [ngModel]="(salaryFilter$ | async).announcementTypeId">
    <div *ngFor="let annType of announcementTypeOptions$ | async" style="margin-top: 0.625rem;">
        <mat-radio-button [value]="annType.announcementTypeId">{{annType.name}}</mat-radio-button>
    </div>
</mat-radio-group> -->
<div *ngIf="announcementFilter$ | async as data" class="container">
    <p-select #dropdown [options]="announcementTypeOptions$ | async"
    [dataKey]="'announcementTypeId'"
    [ngModel]="data.announcementTypeId"
    (ngModelChange)="onChangeAnnuncementTypeFilter($event)"
    [styleClass]="data.announcementTypeId ? 'ann-type-dropdown-selected' : 'ann-type-dropdown'"
    [panelStyleClass]="'dropdown-panel'"
    optionLabel="name"
    optionValue="announcementTypeId"
    [showClear]="data.announcementTypeId"
    [appendTo]="'body'"
    (onClear)="onClearAnnouncementType()"
    autoWidth="false">
    <ng-template let-item pTemplate="item">
        <span class="dropdown-item">{{ item.name }}</span>
    </ng-template>
    
    <ng-template #selectedItem let-selectedOption>
        <span [ngClass]="{'dropdown-value-green' : data.announcementTypeId}">{{ selectedOption?.name }}</span>
    </ng-template>


    <ng-template #dropdownicon>
        <div class="dropdwon-icon">
            <svg-icon src="/assets/icons/arrow-down.svg" [svgClass]="'arrow-class'"></svg-icon>
        </div>
    </ng-template>

    <ng-template #clearicon>
        <div class="dropdwon-icon">
            <svg-icon src="/assets/icons/close-small.svg" [svgClass]="'arrow-class'"></svg-icon>
        </div>
    </ng-template>
</p-select>
</div>
